import { Link, useLocation, useNavigate } from 'react-router-dom';
import Logo from './Logo';
import { navLinks } from '../mock';
const FooterRidge = () => (
  <svg
    className="absolute top-0 left-0 right-0 w-full h-16 opacity-20 pointer-events-none"
    viewBox="0 0 1440 80"
    preserveAspectRatio="none"
    aria-hidden
  >
    <path d="M0 40 L200 20 L400 60 L600 15 L800 55 L1000 25 L1200 50 L1440 30" stroke="#8DA9C4" strokeWidth="1" fill="none" />
    <path d="M0 60 L220 40 L440 70 L640 30 L860 65 L1080 42 L1280 60 L1440 48" stroke="#8DA9C4" strokeWidth="1" fill="none" opacity="0.5" />
  </svg>
);

const FooterNav = ({ goTo }) => (
  <div className="md:col-span-3">
    <div className="text-[12px] uppercase tracking-[0.22em] font-semibold text-slate-500 mb-4">
      Navigate
    </div>
    <ul className="space-y-2.5">
      {navLinks.map((l) => (
        <li key={l.href}>
          <button onClick={() => goTo(l.href)} className="text-[14px] text-slate-300 hover:text-white transition-colors">
            {l.label}
          </button>
        </li>
      ))}
    </ul>
  </div>
);

const FooterProducts = () => (
  <div className="md:col-span-4">
    <div className="text-[12px] uppercase tracking-[0.22em] font-semibold text-slate-500 mb-4">
      Products
    </div>
    <ul className="space-y-2.5">
      <li><Link to="/product/axiom" className="text-[14px] text-slate-300 hover:text-white transition-colors">AXIOM — Virtual Underwriter</Link></li>
      <li><Link to="/product/art" className="text-[14px] text-slate-300 hover:text-white transition-colors">ART — AI Rendered Title</Link></li>
      <li><Link to="/product/truenorth" className="text-[14px] text-slate-300 hover:text-white transition-colors">TrueNorth — Survey Intelligence</Link></li>
      <li><a href="tel:+12535407333" className="text-[14px] text-slate-300 hover:text-white transition-colors" data-testid="footer-phone">(253) 540-7333</a></li>
      <li><a href="mailto:sales@northwesttitlealliance.com" className="text-[14px] text-slate-300 hover:text-white transition-colors">sales@northwesttitlealliance.com</a></li>
    </ul>
  </div>
);

const FooterBottomBar = () => (
  <div className="mt-14 pt-6 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
    <div className="text-[12.5px] text-slate-500" data-testid="footer-legal">
      © {new Date().getFullYear()} Northwest Title Alliance, DBA Northwest Tech Alliance. All rights reserved.
    </div>
    <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
      <a
        href="https://www.northwesttechalliance.com/"
        target="_blank"
        rel="noreferrer"
        className="text-[12.5px] text-slate-500 hover:text-slate-300 transition-colors"
        data-testid="footer-tech-alliance-link"
      >
        Serving national customers? Visit Northwest Tech Alliance ↗
      </a>
      <Link
        to="/brand"
        className="text-[12.5px] text-slate-600 hover:text-slate-400 transition-colors"
        data-testid="footer-brand-link"
      >
        Brand assets
      </Link>
    </div>
  </div>
);

const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const goTo = (href) => {
    if (location.pathname !== '/') {
      navigate(`/${href}`);
    } else {
      const el = document.querySelector(href);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="relative bg-[#0B2545] text-slate-300">
      <FooterRidge />
      <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-16 pb-10">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <Logo variant="dark" />
            <p className="mt-5 text-[14px] leading-relaxed text-slate-400 max-w-md">
              Modern, AI-powered tools built for Washington State title professionals — designed by
              people who have lived the work.
            </p>
          </div>
          <FooterNav goTo={goTo} />
          <FooterProducts />
        </div>
        <FooterBottomBar />
      </div>
    </footer>
  );
};

export default Footer;
